<template>
  <div class="menu-icon-container">
    <img class="menu-icon-img" :src="img" :alt="label">
    <div class="menu-icon-label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: ['icon', 'label'],
  computed: {
    img () {
      return `${process.env.BASE_URL}icons/${this.icon}.svg`
    }
  }
}
</script>

<style lang="scss">
  .menu-icon-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    .menu-icon-img {

    }
    .menu-icon-label {
      font-family: Georgia;
      font-size: 12px;
      line-height: 1.33;
      color: #18333c;
      margin: 16px;
    }
  }
</style>
